import { Nav, Tab } from 'react-bootstrap';
import { PageActionsDesigner, PageControlsDesigner } from './components';

import { DesignEvent } from '../../../../base/models';
import { FC } from 'react';
import { IPage } from '../../models';
import { MUIIcon } from '../../../../widgets';

interface IPageDesignerProps {
    page: IPage,
    onDesignChange: (event: DesignEvent) => void
}

export const PageDesigner: FC<IPageDesignerProps> = ({ page, onDesignChange }) => {
    return (
        <div>
            <Tab.Container defaultActiveKey="controls">
                <Nav variant="pills">
                    <Nav.Item>
                        <Nav.Link eventKey="controls">
                            <div className='d-flex gap-1 fs-7 align-items-center'>
                                <MUIIcon iconName='ConstructionOutlined' className='fs-6' />
                                <span>Controls</span>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="actions">
                            <div className='d-flex gap-1 fs-7 align-items-center'>
                                <MUIIcon iconName='SmartButtonOutlined' className='fs-6' />
                                <span>Actions</span>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content className="mt-2">
                    <Tab.Pane eventKey="controls">
                        <PageControlsDesigner page={page} onDesignChange={onDesignChange} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="actions">
                        <PageActionsDesigner page={page} onDesignChange={onDesignChange} />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    )
}

